import {
    ADDITIONAL_CMS_SITE_STRUCTURE,
    ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_MSISDN,
    TRACKING_NOT_LOGGED_IN,
    TRACKING_PAGE_TYPE,
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA,
} from '../constant';

/**
 * getTrackingPayload
 */
export const getTrackingPayload = (
    siteStructure = [
        ...ADDITIONAL_CMS_SITE_STRUCTURE,
        ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_MSISDN,
    ],
    loginStatus = TRACKING_NOT_LOGGED_IN,
) => ({
    tealiumUseDCF: true,
    pageType: TRACKING_PAGE_TYPE,
    loginStatus,
    siteArea: TRACKING_SITE_AREA,
    platformType: TRACKING_PLATFORM_TYPE_RESPONSIVE,
    siteStructure,
});
